















































import { ObjectType } from 'expangine-runtime';
import { ObjectFormOptions } from './ObjectFormTypes';
import TypeInputBase from '../TypeInputBase';
import ObjectFormField from './ObjectFormField.vue';


export default TypeInputBase<ObjectType, ObjectFormOptions, object>(Object).extend({
  name: 'ObjectForm',
  components: {
    ObjectFormField,
  },
  computed: {
    propsOutside(): string[] {
      const columns = this.settings.options.columns;
      const props = this.type.options.props;
      const propsCopy = Object.assign({}, props);
      
      for (const col of columns) {
        delete propsCopy[col.prop];
      }

      return Object.keys(propsCopy);
    },
  },
});
